"use client";
import React from "react";

const ItemRecentLineupComponent = ({ number, position, name, styles = {} }) => {
  const {
    container = "flex gap-[7px] text-[10px] text-dark-gray dark:text-stroke-o3 items-center ",
    numberClass = "bg-custom-gradient-number-lineup text-white",
    positionClass ="w-[16px] font-bold",
    nameClass = "col-span-3 overflow-hidden line-clamp-1 flex-1 leading-[19px]",
  } = styles;

  return (
    <div className={container}>
      <div className={`w-[27px] py-[2px] pl-[6px] rounded-[4px] font-bold ${numberClass}`}>{number}</div>
      {position && <div className={positionClass}>{position}</div>}
      <div className={nameClass}>{name}</div>
    </div>
  );
};

const ItemRecentLineup = ({ number, position, name, styles }) => {
  return (
    <ItemRecentLineupComponent
      number={number}
      position={position}
      name={name}
      styles={styles}
    />
  );
};

export default React.memo(ItemRecentLineup);
